var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9181 6.98242H40.1116L24.9846 25.9009L9.9181 6.98242ZM1.61546 5.81133C7.71439 13.5889 18.9765 28.0029 18.9765 28.0029V46.0205C18.981 46.8184 19.3011 47.582 19.8668 48.1447C20.4325 48.7073 21.1979 49.0232 21.9957 49.0234H28.0343C28.8322 49.0233 29.5976 48.7074 30.1633 48.1447C30.7291 47.5821 31.0491 46.8184 31.0536 46.0205V28.0029C31.0536 28.0029 42.2855 13.5889 48.3849 5.81133C49.9244 3.8293 48.5053 0.976562 45.9993 0.976562H4.00072C1.49466 0.976562 0.0756195 3.8293 1.61546 5.81133Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.62d3e7941a529b24dffdc5dd2e8fe101.svg";
export { ForwardRef as ReactComponent };